/* This resets embedded videos on modal hide and on carousel slide (so they aren't in the wrong place when autoplaying) */
export function dropdownClassListener() {
  ["hide.bs.dropdown", "show.bs.dropdown"].forEach((eventName) => {
    document.body.addEventListener(eventName, (event) => {
      const mytarget = event.target;
      
      const myparent = mytarget.closest(".navHeader__navLink");
      if(myparent && typeof(myparent) !== undefined) {
      if (eventName == "show.bs.dropdown") {
        myparent.classList.add("navHeader__navLink--active");
      } else {
        myparent.classList.remove("navHeader__navLink--active");
      }
    }
    });
  });
}

/* This deals with overflow on the mobile toggles */
export function menuBarListener() {
  ["shown.bs.collapse", "hidden.bs.collapse"].forEach((eventName) => {
    document.body.addEventListener(eventName, (event) => {
      if (event.target.classList.contains("navHeader__content--mobile")) {
        const menu = document.querySelector("#navbarContent");
        if (menu.classList.contains("show")) {
          document.body.classList.add("utility--overflowHidden");
        } else {
          document.body.classList.remove("utility--overflowHidden");
          const allMenus = document.querySelectorAll(
            ".navHeader__content--mobile",
          );
          [...allMenus].map((collapseEl) =>
            collapseEl.classList.remove("show"),
          );
        }
      }
    });
  });
}

export function doorsAnimationListener() {
  const reverseDuration = 250;
  const doorItems = document.querySelectorAll(".feature--doors .doors__item");

  doorItems.forEach((doorItem) => {
    const doorContent = doorItem.querySelector(".doors__content");
    const doorButton = doorItem.querySelector(".doors__button");
    const backButton = doorItem.querySelector(".backlink[data-bs-target]");

    if (!doorContent || !doorButton) {
      return;
    }

    if (backButton) {
      backButton.addEventListener("click", (event) => {
        if (
          doorItem.classList.contains("is-closing") ||
          !doorContent.classList.contains("show")
        ) {
          return;
        }

        event.preventDefault();
        doorItem.classList.add("is-closing");
        doorItem.classList.remove("is-opening", "is-open");

        window.setTimeout(() => {
          doorButton.click();
        }, reverseDuration);
      });
    }

    doorContent.addEventListener("show.bs.collapse", () => {
      doorItem.classList.add("is-opening");
      doorItem.classList.remove("is-closing");
    });

    doorContent.addEventListener("shown.bs.collapse", () => {
      doorItem.classList.add("is-open");
      doorItem.classList.remove("is-opening");
    });

    doorContent.addEventListener("hide.bs.collapse", () => {
      doorItem.classList.add("is-closing");
      doorItem.classList.remove("is-opening", "is-open");
    });

    doorContent.addEventListener("hidden.bs.collapse", () => {
      doorItem.classList.remove("is-closing");
    });
  });
}

function positionPeopleGridItems(grid, rowCount) {
  const items = Array.from(grid.children);

  if (!items.length || rowCount < 1) {
    return;
  }

  const columnCount = Math.ceil(items.length / rowCount);

  items.forEach((item, index) => {
    const row = Math.floor(index / columnCount) + 1;
    const column = (index % columnCount) + 1;

    item.style.gridRow = String(row);
    item.style.gridColumn = String(column);
  });
}

export function peopleGridOrderListener() {
  const vipGrid = document.querySelector(".feature--people .people__grid--vips");
  const otherGrid = document.querySelector(".feature--people .people__grid--other");

  if (!vipGrid && !otherGrid) {
    return;
  }

  let scheduled = false;

  const syncGridOrder = () => {
    scheduled = false;

    if (vipGrid) {
      positionPeopleGridItems(vipGrid, 2);
    }

    if (otherGrid) {
      positionPeopleGridItems(otherGrid, 3);
    }
  };

  const requestSync = () => {
    if (scheduled) {
      return;
    }

    scheduled = true;
    window.requestAnimationFrame(syncGridOrder);
  };

  requestSync();
  window.addEventListener("resize", requestSync);
}

export function prefooterTiltListener() {
  const trigger = document.querySelector(".prefooter__wrapper");
  const container = trigger ? trigger.querySelector(".prefooter__inner") : null;
  const constraint = 18;

  if (
    !trigger ||
    !container ||
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  ) {
    return;
  }

  function getMaxScale() {
    if (window.innerWidth >= 1400) {
      return 1.005;
    }

    if (window.innerWidth >= 992) {
      return 1.01;
    }

    return 1.015;
  }

  function updateRotation(event) {
    const box = trigger.getBoundingClientRect();
    const centerX = box.x + (box.width / 2);
    const centerY = box.y + (box.height / 2);
    const offsetX = event.clientX - centerX;
    const offsetY = event.clientY - centerY;
    const maxScale = getMaxScale();
    const rotateY = offsetX / constraint;
    const rotateX = -(offsetY / constraint);
    const normalizedDistance = Math.min(
      1,
      Math.hypot(offsetX, offsetY) / Math.hypot(box.width / 2, box.height / 2),
    );
    const scale = Math.min(
      maxScale,
      1 + ((1 - normalizedDistance) * (maxScale - 1)),
    );

    container.style.setProperty("--prefooter-rotate-x", `${rotateX}deg`);
    container.style.setProperty("--prefooter-rotate-y", `${rotateY}deg`);
    container.style.setProperty("--prefooter-scale", scale.toFixed(4));
  }

  function resetRotation() {
    container.style.setProperty("--prefooter-rotate-x", "0deg");
    container.style.setProperty("--prefooter-rotate-y", "0deg");
    container.style.setProperty("--prefooter-scale", "1");
  }

  trigger.addEventListener("mousemove", updateRotation);
  trigger.addEventListener("mouseleave", resetRotation);
  trigger.addEventListener("blur", resetRotation, true);
  resetRotation();
}
